import { render, staticRenderFns } from "./SpecialConfig.vue?vue&type=template&id=3d65237f&scoped=true&"
import script from "./SpecialConfig.vue?vue&type=script&lang=js&"
export * from "./SpecialConfig.vue?vue&type=script&lang=js&"
import style0 from "./SpecialConfig.vue?vue&type=style&index=0&id=3d65237f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d65237f",
  null
  
)

export default component.exports